import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {MultiSelect} from '../../../../../ui/components/common/MultiSelect';
import {IElement} from '../../../../../incase-domain/elements';
import Label from '../../../../../incase-domain/components/label/Label';

interface ElementToDisplayAfterClickProps {
    slideElementOptions: {
        label: string;
        value: string;
    }[];
    elementToDisplayAfterClick: string[];
    highlightedElementChangeHandler: {single: (field: keyof IElement, value: unknown) => void};
    disabled?: boolean;
}

ElementToDisplayAfterClick.defaultProps = {
    disabled: false,
};

function ElementToDisplayAfterClick(props: ElementToDisplayAfterClickProps): ReactElement {
    const {slideElementOptions, elementToDisplayAfterClick, highlightedElementChangeHandler, disabled} = props;
    const {t} = useTranslation();

    function mapSelectedOptions(options: string[]): {label: string; value: string}[] {
        const resOptions: {label: string; value: string}[] = [];

        options.forEach((option) => {
            const item = slideElementOptions.find((item) => item.value === option);

            if (item) resOptions.push(item);
        });

        return resOptions;
    }

    return (
        <div>
            <Label>{t('designSidepanel.elementsToDisplayAfterClick')}</Label>
            <MultiSelect
                disabled={disabled}
                options={slideElementOptions}
                value={mapSelectedOptions(elementToDisplayAfterClick)}
                onChange={(e) => {
                    if (e)
                        highlightedElementChangeHandler.single(
                            'elementToDisplayAfterClick',
                            e.map((item) => item.value)
                        );
                }}
            />
        </div>
    );
}

export default ElementToDisplayAfterClick;
